import { render } from "./product-attachment.vue?vue&type=template&id=77fdef0b"
import script from "./product-attachment.vue?vue&type=script&lang=js"
export * from "./product-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__